import { useEffect } from "react";
import { useState } from "react";
import { Card, CardBody } from 'reactstrap';
import { authHeader } from "../../helpers/auth-header";
import { handleBackground } from "../../helpers/general";
import JsonToHtml from "../controls/JsonToHtml";
import NavMenu from "../layout/NavMenu";
;


const FAQs = () => {
    const [faqsURL, setFaqsURL] = useState('');

    useEffect(() => {

        fetch(`./Settings/GetWebSetting?settingname=faqs_url`, {
            method: 'GET',
            headers: authHeader(false, true)
        })
            .then(response => response.json())
            .then(urlData => {
                setFaqsURL(urlData);
            })
            .catch(err => {
                console.log(err);
            });

        handleBackground();
    }, []);

    return (
        <>
            <NavMenu />

            {faqsURL !== '' &&
                <div className="main-content u-container">
                    <Card className='c-card u-component-spacing'>
                        <CardBody>
                            <JsonToHtml
                                url={faqsURL}
                                jsonPropertyPath={'sell2faqs'}
                                componentID='faqs'
                            />
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}

export default FAQs;